<template>
    <div class="block">
        <div class="ml-4 flex items-center md:ml-6">
            <div class="ml-3 relative">
                <LanguageSelectorItem v-for="(appLanguage, index) in appLanguages" :key="appLanguage.code"
                                      :language="appLanguage" :active="currentAppLanguage === appLanguage.code"
                                      @select-language="(code) => selectCurrentAppLanguage(code)"
                                      :last="index >= appLanguages.length-1"
                                      :dark="dark"  >
                </LanguageSelectorItem>
            </div>
        </div>
    </div>
</template>

<script setup>

defineProps({

    dark: {
        type: Boolean,
        required: false,
        default: false
    },
})

import LanguageSelectorItem from "./LanguageSelectorItem";

import {storeToRefs} from 'pinia'
import {useLanguageStore} from '../stores/language'

const {selectCurrentAppLanguage} = useLanguageStore()
const {appLanguages, currentAppLanguage} = storeToRefs(useLanguageStore())

</script>
